import { createAction } from "redux-actions";
import { takeLatest, put, select, call, all } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../../utils/queryParams";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const FETCH_POS_MODAL_DATA_SUCCESS =
  "./numberOfActiveMembersBy/FETCH_POS_MODAL_DATA_SUCCESS";
export const FETCH_CURRENT_USER_SUCCESS = "./numberOfActiveMembersBy/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_TABLECHART_SUCCESS = "./numberOfActiveMembersBy/FETCH_TABLECHART_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "./numberOfActiveMembersBy/FETCH_FILTERS_SUCCESS";
export const FETCH_POS_MODAL_DATA = "./numberOfActiveMembersBy/FETCH_POS_MODAL_DATA";
export const FETCH_CHART_SUCCESS = "./numberOfActiveMembersBy/FETCH_CHART_SUCCESS";
export const FETCH_TOTAL_SUCCESS = "./numberOfActiveMembersBy/FETCH_TOTAL_SUCCESS";
export const FETCH_CURRENT_USER = "./numberOfActiveMembersBy/FETCH_CURRENT_USER";

export const SET_MEMBERSHIP_LOGIC = "./numberOfActiveMembersBy/SET_MEMBERSHIP_LOGIC";
export const SET_UPDATES_LOADING = "./numberOfActiveMembersBy/SET_UPDATES_LOADING";
export const SET_FILTERS_LOADING = "./numberOfActiveMembersBy/SET_FILTERS_LOADING";
export const SET_FILTERS_DIRTY = "./numberOfActiveMembersBy/SET_FILTERS_DIRTY";
export const SET_LOADING = "./numberOfActiveMembersBy/SET_LOADING";
export const SET_DATES = "./numberOfActiveMembersBy/SET_DATES";

export const UPDATE_MEMBERSHIP_METRIC_FILTER =
  "./numberOfActiveMembersBy/UPDATE_MEMBERSHIP_METRIC_FILTER";
export const UPDATE_TABLE_VIEW_SELECTED = "./numberOfActiveMembersBy/UPDATE_TABLE_VIEW_SELECTED";
export const UPDATE_MEMBERSHIP_METRIC = "./numberOfActiveMembersBy/UPDATE_MEMBERSHIP_METRIC";
export const UPDATE_CUSTOM_RANGE = "./numberOfActiveMembersBy/UPDATE_CUSTOM_RANGE";
export const UPDATE_PERIOD_TYPE = "./numberOfActiveMembersBy/UPDATE_PERIOD_TYPE";
export const UPDATE_TABLE_VIEW = "./numberOfActiveMembersBy/UPDATE_TABLE_VIEW";
export const UPDATE_FILTERS = "./numberOfActiveMembersBy/UPDATE_FILTERS";
export const UPDATE_DATES = "./numberOfActiveMembersBy/UPDATE_DATES";
export const UPDATE_CHART = "./numberOfActiveMembersBy/UPDATE_CHART";

export const RESET_FILTER_SELECTED = "./numberOfActiveMembersBy/RESET_FILTER_SELECTED";
export const RESET_FILTER = "./numberOfActiveMembersBy/RESET_FILTER";

const TOGGLE_PREDICTION = "./numberOfActiveMembersBy/TOGGLE_PREDICTION";
export const TOGGLE_PREDICTION_SELECTED = "./numberOfActiveMembersBy/TOGGLE_PREDICTION_SELECTED";
export const FETCH_PREDICTION_SUCCESS = "./numberOfActiveMembersBy/FETCH_PREDICTION_SUCCESS";
export const SET_PREDICTION_LOADING = "./numberOfActiveMembersBy/SET_PREDICTION_LOADING";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER),
  updateTableView: createAction(UPDATE_TABLE_VIEW),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateMembershipMetric: createAction(UPDATE_MEMBERSHIP_METRIC),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  fetchPosModalData: createAction(FETCH_POS_MODAL_DATA),
  updateFilters: createAction(UPDATE_FILTERS),
  togglePrediction: createAction(TOGGLE_PREDICTION)
};

export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_DATES, updateDates);
  yield takeLatest(RESET_FILTER, resetFilters);
  yield takeLatest(UPDATE_TABLE_VIEW, updateTableView);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(FETCH_POS_MODAL_DATA, fetchPosModalData);
  yield takeLatest(UPDATE_MEMBERSHIP_METRIC, fetchModuleDataByMetric);
  yield takeLatest(TOGGLE_PREDICTION, togglePrediction);
}

const allSagas = [getTotal(), fetchChart(), fetchTableChart()];

export function* fetchCurrentUserData({ payload }) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: payload
  });
  yield put({
    type: SET_MEMBERSHIP_LOGIC,
    payload: payload.membership_metric
  });

  yield put({ type: SET_LOADING, payload: true });
  yield setDates();
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchModuleDataByMetric({ payload }) {
  yield put({ type: UPDATE_MEMBERSHIP_METRIC_FILTER, payload: payload });
  yield put({ type: TOGGLE_PREDICTION_SELECTED, payload: false });
  yield put({ type: SET_LOADING, payload: true });

  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield put({ type: RESET_FILTER_SELECTED });
    yield setDates();

    if (payload.id === "membershipType") {
      yield fetchFilters();
    }

    yield fetchChartsData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchChartsData() {
  const { membership_type_ids } = yield getApiParams();
  const selectedMembershipMetric = yield select(
    (state) => state.numberOfActiveMembersBy.selectedMembershipMetric
  );
  const allSaga = [fetchChart(), fetchTableChart(), getTotal()];

  try {
    if (selectedMembershipMetric.id === "membershipType" && membership_type_ids === "") {
      return;
    }
    yield all(allSaga);
  } catch (error) {
    console.error(error);
  }
}

export function* fetchChart() {
  const {
    organization_id,
    short_url,
    startDate,
    endDate,
    table_view,
    period,
    group_by,
    membership_type_ids,
    apiPath
  } = yield getApiParams();

  let params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate,
    table_view,
    period_type: period
  };

  let url = queryParams.apiVersion + `pages/memberships/${apiPath}`;

  if (apiPath === "by_membership_type") {
    params.membership_type_ids = membership_type_ids;
    params.group_by = group_by;
    url = queryParams.apiVersion + `pages/memberships/${apiPath}/get_chart`;
  }

  try {
    let usePost = url.includes("by_membership_type");
    let { data } = yield call(usePost ? axios.post : axios.get, url, usePost ? params : { params });
    yield put({ type: FETCH_CHART_SUCCESS, payload: data.data });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchTableChart() {
  const {
    organization_id,
    short_url,
    startDate,
    endDate,
    period,
    apiPath,
    membership_type_ids,
    group_by
  } = yield getApiParams();

  const params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate,
    period_type: period
  };

  if (apiPath === "by_membership_type") {
    params.membership_type_ids = membership_type_ids;
    params.group_by = group_by;
  }

  let url = queryParams.apiVersion + `pages/memberships/${apiPath}/get_table`;
  try {
    let usePost = url.includes("by_membership_type/");
    let { data } = yield call(usePost ? axios.post : axios.get, url, usePost ? params : { params });
    yield put({ type: FETCH_TABLECHART_SUCCESS, payload: data });
  } catch (err) {
    console.error(err);
  }
}

export function* getTotal({ prediction } = {}) {
  const { organization_id, short_url, startDate, endDate, apiPath, group_by, membership_type_ids } =
    yield getApiParams();
  let params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate,
    ...(prediction && { prediction })
  };
  if (apiPath === "by_membership_type") {
    params.membership_type_ids = membership_type_ids;
    params.group_by = group_by;
  }
  let url = queryParams.apiVersion + `pages/memberships/${apiPath}/get_totals`;

  try {
    let usePost = url.includes("by_membership_type");
    let { data } = yield call(usePost ? axios.post : axios.get, url, usePost ? params : { params });
    yield put({
      type: FETCH_TOTAL_SUCCESS,
      payload: { scorecards: data.scorecards }
    });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchFilters() {
  const { organization_id, short_url, startDate, endDate, apiPath } = yield getApiParams();

  const params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate
  };
  let url = queryParams.apiVersion + `pages/memberships/${apiPath}/get_filters`;

  try {
    yield put({ type: SET_FILTERS_LOADING, payload: true });
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_FILTERS_SUCCESS, payload: data });
    yield put({ type: SET_FILTERS_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchPosModalData() {
  const { organization_id, short_url, apiPath } = yield getApiParams();
  const params = {
    organization_id,
    short_url
  };
  let url = queryParams.apiVersion + `pages/memberships/${apiPath}/get_modal_pos_info`;
  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_POS_MODAL_DATA_SUCCESS, payload: data.tableData });
  } catch (err) {
    console.error(err);
  }
}

function* setDates() {
  const endDate = yield select(
    (state) => state.numberOfActiveMembersBy.currentUser.calendarEndDate
  );
  const startDate = moment(endDate).startOf("days").subtract(30, "days").format(API_DATE_FORMAT);
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* updateDates() {
  const selectedMembershipMetric = yield select(
    (state) => state.numberOfActiveMembersBy.selectedMembershipMetric
  );
  if (selectedMembershipMetric.id !== "membershipType") return;
  yield put({ type: SET_FILTERS_LOADING, payload: true });
  yield fetchFilters();
  yield put({ type: SET_FILTERS_LOADING, payload: false });
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield fetchChartsData();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  const selectedMembershipMetric = yield select(
    (state) => state.numberOfActiveMembersBy.selectedMembershipMetric
  );

  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield setDates();
  yield put({ type: RESET_FILTER_SELECTED });

  try {
    if (selectedMembershipMetric.id === "membershipType") {
      yield fetchFilters();
    }

    yield fetchChartsData();

    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateTableView({ payload }) {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: UPDATE_TABLE_VIEW_SELECTED, payload });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateCustomRange() {
  const selectedMembershipMetric = yield select(
    (state) => state.numberOfActiveMembersBy.selectedMembershipMetric
  );
  yield put({ type: SET_FILTERS_DIRTY, payload: true });

  if (selectedMembershipMetric.id === "membershipType") {
    yield put({ type: SET_FILTERS_LOADING, payload: true });
    yield fetchFilters();
    yield put({ type: SET_FILTERS_LOADING, payload: false });
  }
}

function* fetchPrediction() {
  yield put({ type: SET_PREDICTION_LOADING, payload: true });
  try {
    const { organization_id, short_url, startDate, endDate, apiPath } = yield getApiParams();
    const url = queryParams.apiVersion + `pages/memberships/${apiPath}`;
    const { data } = yield call(axios.get, url, {
      params: {
        organization_id,
        short_url,
        start_date: startDate,
        end_date: endDate,
        prediction: true
      }
    });
    yield put({ type: FETCH_PREDICTION_SUCCESS, payload: data.data });
  } catch (error) {
    console.error(error);
  }
  yield put({ type: SET_PREDICTION_LOADING, payload: false });
}

function* togglePrediction({ payload: enabled }) {
  yield put({ type: TOGGLE_PREDICTION_SELECTED, payload: enabled });
  if (!enabled) {
    yield updateData();
    return;
  }
  yield all([fetchPrediction(), getTotal({ prediction: true })]);
}

function* getApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const {
    selectedRequestDates: { startDate, endDate },
    selectedFilters: { table_view, period_type, membership_types, group_by },
    metric_params: { apiPath }
  } = yield select((state) => state.numberOfActiveMembersBy);

  const period = period_type.toLowerCase();

  return {
    organization_id: organization_id.toString(),
    short_url,
    startDate,
    endDate,
    table_view,
    period,
    membership_type_ids: membership_types.map((obj) => obj.id).join(","),
    apiPath,
    group_by: group_by.id
  };
}
